import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpRequestResponse } from '../../../../lib/models/http-request-response.model';
import { HttpRequestService } from '../../../../lib/services/http-request.service';
import { LogService } from '../../../../lib/services/log.service';
import { lastValueFrom } from 'rxjs';
import { FormControl, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { onlyUppercaseLettersAndNumbersValidator } from '../../../../lib/utils/Utility';

@Component({
    selector: 'app-recupero-password',
    templateUrl: './recupero-password.component.html',
    styleUrls: ['./recupero-password.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ReactiveFormsModule, FormsModule]
})
export class RecuperoPasswordComponent {
  private httpRequestService = inject(HttpRequestService);
  private router = inject(Router);
  private logService = inject(LogService);

  password: string;
  passwordConferma: string;
  codiceFiscale: string;
  code = new FormControl('', [onlyUppercaseLettersAndNumbersValidator(), Validators.required])

  async onSubmitNuovaPassword() {
    if (this.code.invalid) {
      return
    }
    const response = await lastValueFrom(this.httpRequestService
      .post('/reimposta-password', {
        codiceFiscale: this.codiceFiscale.toUpperCase(),
        newPassword: this.password,
        newPasswordConferma: this.passwordConferma,
        code: this.code.value,
      }))

    if (HttpRequestResponse.isSuccessResponse(response)) {
      await lastValueFrom(
        this.logService.messageInfo("Successo", "Password reimpostata con successo").
          afterClosed()
      )

      this.router.navigate(["..", ".."])
    } else {
      this.logService.messageInfo("Attenzione", response?.message);
    }
  }
}
